import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { StockConfig } from '../models/stock-config';

@Injectable({
  providedIn: 'root'
})
export class StockConfigService {


  constructor(private httpClient: HttpClient) { }

  ServiceUrl: string = environment.BaseServiceUrl + "StockConfig";

  public getAll(): Observable<StockConfig[]> {
    let url = this.ServiceUrl;
    return this.httpClient.get<StockConfig[]>(url);
  }
}
